<template>
  <div class="ml-3 is-relative">
    <transition name="fade">
      <p
        v-show="!isLittleScroll"
        class="mb-1 label-12 all-ease-in-out"
        :class="{ 'transition-margin-top': isLittleScroll }"
      >
        {{ title }}
      </p>
    </transition>

    <b-dropdown
      ref="dropdownDates"
      aria-role="menu"
      expanded
      append-to-body
      :close-on-click="false"
      @active-change="handleClickDropdown"
    >
      <template #trigger>
        <div
          ref="refDateFilter"
          class="date-input-wrapper is-clickable px-2 flex-center-vertical is-relative"
          :class="[classInput]"
        >
          <div class="flex-center c-h-100" @click="openDateFilter">
            <ScheduleIcon width="15" height="15" />
            <p class="ml-2 color-black-primary">{{ renderDateFilter }}</p>
          </div>

          <div
            v-if="showCloseDate"
            class="close-wrapper ml-2"
            @click="closeDateFilter({ isReset: true })"
          >
            <XMarkIcon size="10" color="#000" />
          </div>
        </div>
      </template>

      <div class="date-report-progress-wrapper bg-white pt-4 pr-4 pb-4">
        <div class="v-calendar-wrapper p-2">
          <v-date-picker
            v-model="selectedDate"
            is-expanded
            :is-range="!(isUpToDate || isAllTime)"
            :from-page="fromPage"
            color="red"
            @input="handleDateChange"
          />

          <div v-if="isUpToDate" class="pt-2 border-top-1">
            <ErrorComponent title="Pilih Tanggal Akhir" />
          </div>
        </div>

        <div v-if="showPredefine" class="predefine-wrapper pl-3">
          <div class="c-w-100">
            <div
              v-for="(item, index) in listPredefine"
              :key="index"
              class="btn-predefine is-clickable flex-center py-2 mb-3"
              :class="{ active: selectedPredefine === item.value }"
              @click="handleClickPredefine(item.value)"
            >
              <p
                class="label-14 averta-reguler"
                :class="{
                  'averta-bold color-red': selectedPredefine === item.value
                }"
              >
                {{ item.title }}
              </p>
            </div>
            <div class="flex-center mt-4">
              <ButtonApp
                :isSecondary="true"
                @click="closeDateFilter({ isReset: true })"
                class="flex-1 mr-3"
              >
                <p class="averta-bold py-2">Batalkan</p>
              </ButtonApp>
              <ButtonApp class="flex-1" @click="onFilterDate">
                <p class="averta-bold py-2">Pilih</p>
              </ButtonApp>
            </div>
          </div>
        </div>
      </div>
    </b-dropdown>
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  name: 'DropdownFilterDate',
  props: {
    type: {
      type: String,
      default: 'dates'
    },
    isLittleScroll: {
      type: Boolean,
      default: false
    },
    saveValue: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Filter Tanggal'
    },
    showPredefine: {
      type: Boolean,
      default: true
    },
    classInput: {
      type: String,
      default: ''
    },
    variableLS: {
      type: String,
      default: 'report_dates'
    },
    variableEmit: {
      type: String,
      default: 'dates'
    }
  },
  components: {
    ScheduleIcon: () => import('@/components/icons/ScheduleIcon'),
    XMarkIcon: () => import('@/components/icons/XMarkIcon'),
    ButtonApp: () => import('@/components/button/ButtonApp'),
    ErrorComponent: () => import('@/components/ErrorComponent.vue')
  },
  data () {
    return {
      isOpenDate: false,
      renderDateFilter: 'Tanggal Mulai - Selesai',
      selectedDate: null, // { start: date, end: date }
      selectedPredefine: null,
      listPredefine: [
        {
          title: 'Sepanjang Waktu',
          value: 'all-time'
        },
        {
          title: 'Hari ini',
          value: 'today'
        },
        {
          title: 'Kemarin',
          value: 'yesterday'
        },
        {
          title: 'Minggu ini',
          value: 'this-week'
        },
        {
          title: 'Minggu lalu',
          value: 'last-week'
        },
        {
          title: 'Bulan ini',
          value: 'this-month'
        },
        {
          title: 'Bulan lalu',
          value: 'last-month'
        },
        {
          title: '30 Hari Terakhir',
          value: 'last-30-day'
        },
        {
          title: 'Pilih Sampai Tanggal',
          value: 'up-to-date'
        }
      ],
      fromPage: {
        year: parseInt(moment(new Date()).format('YYYY')),
        month: parseInt(moment(new Date()).format('M'))
      },
      fromPageTemp: null
    }
  },
  computed: {
    ...mapGetters({
      tempDateScrollTo: 'report/getTempDateScrollTo',
      payloadFilterReport: 'report/getFilterReportProgress'
    }),
    showCloseDate () {
      if (this.renderDateFilter === 'Tanggal Mulai - Selesai' || !this.renderDateFilter) {
        return false
      }
      return true
    },
    isAllTime () {
      return this.selectedPredefine === 'all-time'
    },
    isUpToDate () {
      return this.selectedPredefine === 'up-to-date'
    }
  },
  methods: {
    openDateFilter () {
      this.isOpenDate = !this.isOpenDate
      const start = (this.selectedDate && this.selectedDate.start) || null
      this.fromPage = this.fromPageTemp || {
        year: parseInt(moment(start || new Date()).format('YYYY')),
        month: parseInt(moment(start || new Date()).format('M'))
      }
      this.handleClickDropdown(true)
    },
    closeDateFilter (props = {}) {
      const { isReset = false } = props
      this.isOpenDate = false

      if (isReset) {
        this.renderDateFilter = 'Tanggal Mulai - Selesai'
        this.selectedDate = null
        this.selectedPredefine = null

        let reset = false
        const isFiltered = JSON.parse(localStorage.getItem('report_clicked_filter'))
        if (isFiltered) {
          reset = true
        }
        this.$emit('selected', { data: this.selectedDate, type: this.variableEmit, reset })
      }

      this.handleClickDropdown(false)
      this.$refs.dropdownDates.toggle()
    },
    onFilterDate (props) {
      if (props) {
        if (props.fromTemp) {
        }
      } else {
        this.$refs.dropdownDates.toggle()
      }

      if (!this.selectedDate) return

      switch (this.selectedPredefine) {
        case 'today':
        case 'yesterday':
          this.renderDateFilter = moment(this.selectedDate.start).format('DD MMM YYYY')
          break
        case 'all-time':
        case 'up-to-date':
          this.renderDateFilter = moment(this.selectedDate).format('DD MMM YYYY')
          break
        default:
          this.renderDateFilter = `${moment(this.selectedDate.start).format(
            'DD MMM YYYY'
          )} - ${moment(this.selectedDate.end).format('DD MMM YYYY')}`
          break
      }

      this.isOpenDate = false
      this.$emit('selected', {
        data: this.selectedDate,
        type: this.variableEmit,
        isUpToDate: this.isUpToDate || this.isAllTime
      })
    },
    handleClickPredefine (value) {
      const initDate = new Date()

      let start = initDate
      let end = initDate

      switch (value) {
        case 'today':
          // No changes needed for today
          break
        case 'yesterday':
          start = moment(initDate).subtract(1, 'day')
          end = moment(initDate).subtract(1, 'day')
          break
        case 'this-week':
          start = moment(initDate).startOf('week')
          end = moment(initDate).endOf('week')
          break
        case 'last-week':
          start = moment(initDate).subtract(1, 'week').startOf('week')
          end = moment(initDate).subtract(1, 'week').endOf('week')
          break
        case 'this-month':
          start = moment(initDate).startOf('month')
          end = moment(initDate).endOf('month')
          break
        case 'last-month':
          start = moment(initDate).subtract(1, 'month').startOf('month')
          end = moment(initDate).subtract(1, 'month').endOf('month')
          break
        case 'last-30-day':
          start = moment(initDate).subtract(29, 'days')
          end = moment(initDate)
          break
        default:
          break
      }

      const resultStart = new Date(start)
      const resultEnd = new Date(end)

      this.fromPageTemp = null
      this.fromPage = {
        year: parseInt(moment(resultStart).format('YYYY')),
        month: parseInt(moment(resultStart).format('M'))
      }

      const notRange = value === 'up-to-date' || value === 'all-time'
      if (notRange) {
        this.selectedDate = resultStart
      } else {
        this.selectedDate = { start: resultStart, end: resultEnd }
      }

      this.selectedPredefine = value
      this.$store.commit('report/setTempDateScrollTo', null)
    },
    handleDateChange (value) {
      this.selectedDate = value
      const resultStart = new Date(value.start)

      this.fromPageTemp = {
        year: parseInt(moment(resultStart).format('YYYY')),
        month: parseInt(moment(resultStart).format('M'))
      }

      if (!this.isUpToDate) {
        this.selectedPredefine = null
      }
      this.$store.commit('report/setTempDateScrollTo', null)
    },
    handlePageRefresh () {
      const temp = {
        renderDateFilter: this.renderDateFilter,
        selectedDate: this.selectedDate,
        selectedPredefine: this.selectedPredefine
      }
      localStorage.setItem(this.variableLS, JSON.stringify(temp))
    },
    handleClickDropdown (value) {
      this.$emit('clickedDropdown', value)
    }
  },
  mounted () {
    const temp = localStorage.getItem(this.variableLS)
    if (temp && temp !== 'undefined') {
      const {
        renderDateFilter: title,
        selectedDate: date,
        selectedPredefine: predefine
      } = JSON.parse(temp)
      const isReset = title === 'Tanggal Mulai - Selesai'

      this.selectedPredefine = isReset ? null : predefine
      this.selectedDate = isReset ? null : date || { start: new Date(), end: new Date() }
      this.renderDateFilter = title || moment(new Date()).format('DD MMM YYYY')

      this.$emit('selected', { data: this.selectedDate, type: this.variableEmit })
    } else if (this.variableLS === 'report_dates') {
      this.renderDateFilter = moment(new Date()).format('DD MMM YYYY')
      this.handleClickPredefine('today')
    }
  },
  created () {
    window.addEventListener('beforeunload', this.handlePageRefresh)
    if (this.type === 'due_dates') {
      this.listPredefine.shift()
      this.listPredefine.pop()
    }
  },
  beforeDestroy () {
    window.removeEventListener('beforeunload', this.handlePageRefresh)
  },
  watch: {
    tempDateScrollTo (val) {
      if (val && this.type === 'dates') {
        this.fromPageTemp = {
          year: parseInt(moment(val.startDate).format('YYYY')),
          month: parseInt(moment(val.startDate).format('M'))
        }
        this.selectedDate = { start: val.startDate, end: val.endDate }
        this.selectedPredefine = null
        this.onFilterDate({ fromTemp: true })
      }
    },
    selectedDate (val) {
      if (this.saveValue) {
        this.$store.commit('report/setSaveDateFilterProgress', val)
      }
    },
    payloadFilterReport: {
      handler (val) {
        if (this.type === 'dates' && val && val.payloadDates) {
          const date = val.payloadDates

          if (date.start) {
            const resultStart = new Date(date.start)
            const resultEnd = new Date(date.end)

            this.fromPageTemp = null
            this.fromPage = {
              year: parseInt(moment(resultStart).format('YYYY')),
              month: parseInt(moment(resultStart).format('M'))
            }
            this.selectedDate = { start: resultStart, end: resultEnd }

            const start = moment(date.start).format('DD MMM YYYY')
            const end = moment(date.end).format('DD MMM YYYY')

            if (start === end) {
              this.renderDateFilter = start
            } else {
              this.renderDateFilter = `${start} - ${end}`
            }
          } else {
            this.selectedDate = date
            this.renderDateFilter = moment(date).format('DD MMM YYYY')
          }
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/scss/_variables.scss';

.date-input-wrapper {
  border: 1px solid $color-grey-2;
  border-radius: 5px;
  overflow: hidden;
  min-width: 14em;
  height: 2.65em;
}

.date-report-progress-wrapper {
  position: absolute;
  right: 0;
  z-index: 5;
  display: flex;
  box-shadow: 0 0.5em 1em -0.125em rgba(10, 10, 10, 0.1), 0 0px 0 1px rgba(10, 10, 10, 0.02);
  border-radius: 8px;
}

.predefine-wrapper {
  width: 15em;
  position: relative;
  z-index: 1;
  background: $color-white;
  display: flex;
  justify-content: center;
  border-left: 1px solid $color-grey-2;
}

.btn-predefine {
  border-radius: 100px;
  border: 1px solid $color-grey-2;
  background: $color-white;
  transition: 0.05s all ease-in-out;
}

.btn-predefine.active {
  border: 1px solid $color-red-1;
  background: $color-pink-2;
}

.btn-tanggal {
  width: 100%;
  border-radius: 20px;
  border: 1px $color-dark-grey-2 solid;
}

.btn-tanggal:hover {
  width: 100%;
  border-radius: 20px;
  border: 1px $color-red-1 solid;
  background: $color-grey-12;
  color: $color-red-1;
  font-family: 'Averta-Bold';
}

.close-wrapper {
  position: absolute;
  right: 7px;
  top: 7px;
}

.v-calendar-wrapper {
  width: 25em;
}
</style>

<style>
.v-calendar-wrapper .vc-container {
  border: none !important;
  font-family: 'Averta' !important;
}

.v-calendar-wrapper .vc-grid-cell {
  margin-bottom: 10px !important;
}

.v-calendar-wrapper .vc-day-content {
  height: 35px !important;
  width: 35px !important;
  font-size: 18px !important;
}

.v-calendar-wrapper .vc-weekday {
  font-size: 18px !important;
}

.v-calendar-wrapper .vc-highlight.vc-highlight-base-start {
  height: 100% !important;
}

.v-calendar-wrapper .vc-highlight.vc-highlight-base-end {
  height: 100% !important;
}

.v-calendar-wrapper .vc-highlight.vc-highlight-base-middle {
  height: 100% !important;
  width: 100% !important;
}

.v-calendar-wrapper .vc-highlight {
  width: 38px !important;
  height: 38px !important;
}
</style>
